import axios from "../index"

// 接口基础路径
const rootApi = '/api_v2/process'


/** 获取工序分类所有节点 */
export const processTreeData = () => {
  return axios.get(`${rootApi}/allNodes`)
}

/** 工序列表分页查询 */
export const processPage = (params) => {
  return axios.get(`${rootApi}/page`, {params})
}

/** 工序分类查询 */
// export const queryProcessCategory = (processId) => {
//   return axios.get(`${rootApi}/${processId}/category`)
// }

/** 工序阿洛丁管控标准定义 */
export const queryAlodineDefine = (processId) => {
  return axios.get(`${rootApi}/${processId}/alodineDefine`)
}

/** 工序喷涂管控标准定义 */
export const querySprayDefine = (processId) => {
  return axios.get(`${rootApi}/${processId}/sprayDefine`)
}

/** 工序图纸列表 */
export const queryProcessDocList = (processId) => {
  return axios.get(`${rootApi}/${processId}/docList`)
}

/**获取自定义，工序详情列表接口 */
export const  getCustomFieldVals=(params)=>{
  return axios.get(`/api_v2/customFieldVal/getCustomFieldVals`, {params})
}

/**获取自定义，工序详情列表接口 */
export const  editCustomFieldVal=(params)=>{
  return axios.get(`/api_v2/customFieldVal/editCustomFieldVal`, {params})
}

